import { ContractInfoState, ContractInfoStateType } from '@/states/ContractInfoState';
import url from '@/utils/config';
import axios from 'axios';
import { ApiUrl } from '@/utils/constants';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { LoginUserInfoState } from '@/states/LoginUserInfoState';
import { useRouter } from 'next/router';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import AtImageLink from '../atoms/AtImageLink';
import AtLink from '../atoms/AtLink';

/** 属性定義 */
type Props = {
  loginid: string;
  className?: string;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const OrHeaderAreaWithLogin = ({
  loginid,
  className
}: Props) => {
  const router = useRouter();
  const resetLoginUserInfo = useResetRecoilState(LoginUserInfoState);
  // ログインユーザー情報
  const loginUserInfo = useRecoilValue(LoginUserInfoState);
  // MANOMA Bizプラン 判定
  const contractInfo = useRecoilValue<ContractInfoStateType>(ContractInfoState);
  const isManomaBizPlan = loginUserInfo && contractInfo?.contractServiceInfo?.planInfo?.manomaBizPlanFlg === '1';
  const headerManoma = (): JSX.Element => {
    return <AtImageLink href='/' data-testid='header-pic' imgSrc={url('/images/logo_manoma.svg')} />;
  };
  const headerManomaBiz = (): JSX.Element => {
    return <AtImageLink href='/' data-testid='header-pic' imgSrc={url('/images/header_logo-manoma-only.png')} />;
  };
  /**
   * ログアウト押下処理
   */
  const clickLogout = async () => {
    const apiUrl = `${process.env.NEXT_PUBLIC_AUTH_URL}${ApiUrl.Authn.LOGOUT}`;
    const headers = await getSigV4HeadersForGet(ApiUrl.Authn.LOGOUT);
    await axios.get(apiUrl, headers).catch().finally(() => {
      resetLoginUserInfo();
      sessionStorage.clear();
      router.push('/account/login');
    });
  };
  return <header className={`orheaderareawithlogin ${className}`}>
      <p className='headTtl'>{isManomaBizPlan ? headerManomaBiz() : headerManoma()}</p>
      <div className='memberArea'>
        <p>
          <span className='strong'>{loginid}</span>でログインしています
        </p>
        <ul>
          <li>
            <AtLink href='https://manoma.jp/emerge/' target='_blank' rel='noreferrer'>
              障害・メンテナンス情報
            </AtLink>
          </li>
          <li>
            <AtLink href='/account/contract-change'>アカウント情報変更</AtLink>
          </li>
          <li>
            <AtLink href='' onClick={clickLogout}>
              ログアウト
            </AtLink>
          </li>
        </ul>
      </div>
    </header>;
};
/** 初期値の設定 */
OrHeaderAreaWithLogin.defaultProps = {
  className: ''
};
export default OrHeaderAreaWithLogin;